import { Box } from "@mui/material";

interface PointsBadgeProps {
  amount: number;
  variant?: "default" | "animated" | "selected" | "large";
  position?: "absolute" | "relative";
}

export const PointsBadge = ({
  amount,
  variant = "default",
  position = "absolute",
}: PointsBadgeProps) => {
  const getVariantStyles = () => {
    switch (variant) {
      case "animated":
        return {
          bgcolor: "#FFD700",
          background:
            "linear-gradient(90deg, #ffd700, #ffeb3b, #ffd700, #ffeb3b)",
          backgroundSize: "200% 100%",
          animation: "glimmer 8s ease-in-out infinite",
          fontWeight: 700,
          fontSize: { xs: "0.8rem", sm: "0.875rem" },
          color: "white",
          borderRadius: 1.5,
          px: { xs: 1.25, sm: 1.5 },
          py: { xs: 0.4, sm: 0.5 },
          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.15)",
        };
      case "selected":
        return {
          bgcolor: "success.main",
          fontWeight: 700,
          fontSize: { xs: "0.8rem", sm: "0.875rem" },
          color: "white",
          borderRadius: 1.5,
          px: { xs: 1.25, sm: 1.5 },
          py: { xs: 0.4, sm: 0.5 },
          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.15)",
        };
      case "large":
        return {
          background: "#FFD700",
          color: "text.primary",
          borderRadius: 1,
          px: 2,
          py: 0.75,
          fontWeight: 800,
          fontSize: { xs: "1.25rem", sm: "1.4rem" },
          boxShadow: "0 2px 6px rgba(255, 193, 7, 0.3)",
        };
      default:
        return {
          bgcolor: "gold",
          fontWeight: "400",
          color: "inherit",
          borderWidth: "0 0 1px 1px",
          borderStyle: "solid",
          borderColor: "#aaa",
          borderRadius: "0 0 0 0.5rem",
          p: "10px",
          fontSize: 14,
        };
    }
  };

  return (
    <Box
      data-cypress="points-badge"
      sx={{
        position: position,
        top: position === "absolute" ? 0 : undefined,
        right: position === "absolute" ? 0 : undefined,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        ...getVariantStyles(),
      }}
    >
      {amount} pts
    </Box>
  );
};
